import React from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'

// import components
import { BestPickTopCard } from './BestPickTopCard'

// styled components via emotion
const BestPicksWrapper = styled.div`
	${({ theme }) => theme.maxWidth.L};
	margin: auto;
	margin-bottom: -125px;
	position: relative;
	top: -125px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		top: -105px;
		margin-bottom: -105px;
	}
`
const TopCardsContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	padding-bottom: 30px;
	margin: auto;
	width: 100%;

	${({ theme }) => theme.MQ.XS} {
		flex-direction: row;
	}

	${({ theme }) => theme.MQ.XL} {
		flex-wrap: nowrap;
		width: auto;
	}
`

BestPicks.propTypes = {
	services: array,
}

/**
 * This is the best picks section
 * displays the featured sponsor listing and any services selected in CCM
 *
 * @param {Array} props.services :: list of services with data about each service
 */

export function BestPicks({ services }) {
	return (
		<BestPicksWrapper>
			<TopCardsContainer>
				{services &&
					services.map((service, i) => {
						return <BestPickTopCard key={service.serviceName} {...service} rank={i} />
					})}
			</TopCardsContainer>
		</BestPicksWrapper>
	)
}
